<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="eval_ouinon" v-model="sasEquivalence.evaluationComparativeDesEtudesObtenue" :live="liveSasEquivalence(6115)" />
    <CatalogueLive
      code="eval_type"
      v-model="sasEquivalence.nomDocument"
      :live="liveSasEquivalence(6116)"
      :opq-if="estOui(sasEquivalence.evaluationComparativeDesEtudesObtenue)"
    />
    <TextFieldLive
      code="eval_autretype"
      v-model="sasEquivalence.autreDocument"
      :live="liveSasEquivalence(6117)"
      :opq-if="estOui(sasEquivalence.evaluationComparativeDesEtudesObtenue) && estAutre(sasEquivalence.nomDocument)"
    />
    <MemoLive
      code="eval_decision"
      v-model="sasEquivalence.decisionDeLEvaluation"
      :live="liveSasEquivalence(6119)"
      :opq-if="estOui(sasEquivalence.evaluationComparativeDesEtudesObtenue)"
    />
    <FileInput
      code="eval_preuve"
      :file="sasEquivalence.preuveDeDecision"
      :live="liveSasEquivalence(6118)"
      :opq-if="estOui(sasEquivalence.evaluationComparativeDesEtudesObtenue)"
      @file-deleted="sasEquivalence.preuveDeDecision = null"
    />
  </v-form>
</template>


<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasEquivalence() {
      return this.sas.sasEquivalence
    }
  },
  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    },
    estAutre(typedoc) {
      return this.getCatalogueCodeById("6116", typedoc) == "autre"
    }
  }
}
</script>

<style>
</style>